export const exportCSV = async (
	response: any,
	name: string,
	format: 'csv' | 'xlsx' = 'xlsx'
) => {
	const mimeType =
		format === 'csv'
			? 'text/csv;charset=utf-8;'
			: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

	const blob = new Blob([response], { type: mimeType });

	const url = window.URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', `${name}.${format}`);
	document.body.appendChild(link);
	link.click();
	link?.parentNode?.removeChild(link);
};
